<template>
  <base-modal
    :title="$t('modal.login.title')"
    :confirmButton="$t('modal.login.confirmBtn')"
    :confirmEnabled="true"
    :showCancelButton="false"
    @close="$emit('close')"
    @confirmed="$emit('confirmed')"
  >
    <div slot="body">
      <p class="modal-text">{{ $t('modal.login.subtitle') }}</p>
    </div>
  </base-modal>
</template>

<script>
export default {
  name: 'login-modal',
  components: {
    BaseModal: () => import('./BaseModal')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/LoginModal.vue